export default function() {
  try {
    return JSON.parse(localStorage.getItem('justo_jwt_data')) || {}
  } catch (error) {
    return {}
  }
}
